module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Dramatis Personae")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyTextFirstPara__And__Left_Indent"
  }, [_vm._v("(Historical figures are denoted by "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_vm._v("ψ")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Jean-Claude (Rod) Simone")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Marie Simone—Rod’s mother")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Henri Simone—Rod’s father")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Nanette Simone—Rod’s sister")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Major General Hank McCluney—Downed pilot, Rod’s adoptive father")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Mary McCluney—Hank’s wife, Rod’s adoptive mother")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Sandy Allison—Rod’s high-school girlfriend in Southern California")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Julie Phillips—Colorado Women’s College student, Rod’s girlfriend in Colorado")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisLocation__And__Left_Indent"
  }, [_vm._v("United States Air Force Academy—Class of 1959")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Nino Baldacci"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_vm._v("ψ")]), _vm._v("—Cadet (Poughkeepsie, NY)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Fred Delante—Cadet (Colorado Springs, CO)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Jeff Goldstein—Cadet (New York, NY)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Sylvester “Sly” Winston Jakes—Cadet (Boston, MA)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Manuel Rojo—Cadet (Albuquerque, NM)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("George Sanders—Cadet (Ft. Worth, Texas)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisLocation__And__Left_Indent"
  }, [_vm._v("United States Air Force Academy")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Master Sergeant William H. Coltrin"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_vm._v("ψ")]), _vm._v("—USAFA Non-commissioned OIC")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Lieutenant General James E. Briggs"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_vm._v("ψ")]), _vm._v("—USAFA Superintendent")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Raf Garcia—waiter")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Lieutenant General Hubert Harmon"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_vm._v("ψ")]), _vm._v("—first USAFA Superintendent")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Captain Samuel P. Justice, USAF—Air Officer Commanding (AOC)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Ben Martin"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_vm._v("ψ")]), _vm._v("—USAFA football coach")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Mrs. Gail McComas"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_vm._v(" ψ")]), _vm._v("—Cadet hostess, 1955 to 1977")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("First Lieutenant Tom Ranch, USAF—Air Training Officer (ATO)")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Brigadier General Robert M. “Moose” Stillman"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_vm._v("ψ")]), _vm._v("—first Commandant of Cadets")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Brigadier Henry R. Sullivan, Jr."), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_vm._v("ψ")]), _vm._v("—Commandant of Cadets")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Colonel Albert E. Stoltz"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_vm._v("ψ")]), _vm._v("—Director, Air Force Academy Construction Agency")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisLocation__And__Left_Indent"
  }, [_vm._v("Colorado Springs")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("George Delante—Land developer and construction magnate")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Elizabeth Delante—his wife")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Jim-Tom Henderson—Owner, Pine Valley Airport and George’s business partner")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Margaret Henderson—his sister")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Darius Moore—El Paso county assistant district attorney")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisLocation__And__Left_Indent"
  }, [_vm._v("Washington, D.C.")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("President Dwight D. Eisenhower"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_vm._v("ψ")]), _vm._v("—U. S. President")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("The Honorable J. Edgar Chenoweth"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_vm._v("ψ")]), _vm._v("—Colorado Congressman")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Ambassador T. Edward Phillips—Julie Phillip’s father")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Francine Phillips—Julie Phillip’s mother")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisLocation__And__Left_Indent"
  }, [_vm._v("Other Locations")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Colonel “Speedy” Beaumont—Hank McCluney’s wingman in WWII")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Carol Gutheinz—Colorado Women’s College student")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Tony Rafelli—"), _c('i', [_vm._v("Denver Post")]), _vm._v(" reporter")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Barbara Richardson—Stanford student")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_DramatisText"
  }, [_vm._v("Wendy Shelby—Colorado Women’s College student")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34f5746a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0007.vue
// module id = 78
// module chunks = 0